import t_12_2498 from './KZ.Т.12.2498.svg'
import t_12_2498_b from './KZ.Т.12.2498 black.svg'

export default [
  t_12_2498,
  t_12_2498_b,
]
